import classNames from "classnames";
import type { GuildForumTag } from "discord.js";
import { ChannelSelectForm } from "../channel_dropdown";

const name: string = null;

export function ChannelSelectFormWithTags(
	props: React.ComponentProps<typeof ChannelSelectForm> & {
		selected_forum_tag_ids: string[];
		setSelectedTagIds: (ids: string[]) => void;
	}
) {
	const selected_channel = props.channel_data.find(
		(val) => val.id === props.initial_value?.id
	);

	const tags: GuildForumTag[] =
		selected_channel?.type === "Forum"
			? selected_channel?.tag_settings.tags
			: [];

	return (
		<div className="field" id={props.id}>
			<ChannelSelectForm {...props} id={undefined} should_check_forum_tag_permissions />
			{selected_channel?.type === "Forum" && (
				<ForumTags
					required={selected_channel.tag_settings.required}
					tags={tags}
					selected_forum_tag_ids={props.selected_forum_tag_ids}
					setSelectedTagIds={props.setSelectedTagIds}
				/>
			)}
		</div>
	);
}

function ForumTags(props: {
	required: boolean;
	tags: GuildForumTag[];
	selected_forum_tag_ids: string[];
	setSelectedTagIds: (ids: string[]) => void;
	disabled?: boolean;
}) {
	if (props.tags.length === 0) {
		return <></>;
	}

	return (
		<div
			className={classNames("flex gap-2 max-w-full overflow-auto pb-1", {
				"input-disabled": props.disabled,
			})}
		>
			<div className="flex-shrink-0">{`Tags${
				props.required ? " (required)" : ""
			} (${props.selected_forum_tag_ids.length}/5):`}</div>
			{props.tags.map((val, index) => (
				<ForumTag
					key={index}
					tag={val}
					is_active={props.selected_forum_tag_ids.includes(val.id)}
					onClick={(id) => {
						if (props.selected_forum_tag_ids.includes(id)) {
							props.setSelectedTagIds(
								props.selected_forum_tag_ids.filter(
									(val) => val !== id
								)
							);
						} else {
							if (props.selected_forum_tag_ids.length < 5) {
								props.setSelectedTagIds(
									props.selected_forum_tag_ids.concat(id)
								);
							}
						}
					}}
				></ForumTag>
			))}
		</div>
	);
}

function ForumTag(props: {
	tag: GuildForumTag;
	is_active: boolean;
	onClick: (id: string) => void;
}) {
	const { tag } = props;
	return (
		<div
			className={classNames("tag forum-tag flex gap-1", {
				active: props.is_active,
			})}
			onClick={() => props.onClick(tag.id)}
		>
			{tag.emoji && <DiscordEmoji emoji={tag.emoji} />}
			{tag.moderated}
			<div className="select-none">{tag.name}</div>
		</div>
	);
}

function DiscordEmoji(props: { emoji: GuildForumTag["emoji"] }) {
	const emoji_element = props.emoji.id ? (
		<img
			className="h-[1em]"
			src={`https://cdn.discordapp.com/emojis/${props.emoji.id}.png`}
		/>
	) : (
		<>{props.emoji.name}</>
	);

	return <span className="self-center">{emoji_element}</span>;
}
